
namespace RioERP.Masters {
    export class PendingOrderJobSettingsColumns {
        static columnsKey = 'Masters.PendingOrderJobSettings';
    }
}